<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap>
        <v-flex xs12>
          <div class="layout row justify-space-between wrap">
            <v-btn small text title="View visit" :href="'/clients/' + client.id + '/visits/' + visit.id" @click.stop.prevent="goTo('/clients/' + client.id + '/visits/' + visit.id)">
              <v-icon left>mdi-arrow-left-bold-outline</v-icon>Visit
            </v-btn>
            <h3 class="mt-0">Treatment</h3>
            <v-btn small text :href="'/clients/' + client.id + '/visits/' + visit.id + '/treatments/create'" @click.stop.prevent="goTo('/clients/' + client.id + '/visits/' + visit.id + '/treatments/create')" title="Add Treatment" class="pull-right">
              <v-icon left>mdi-pill</v-icon>Add Treatment
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 v-if="treatments.length < 1">
          <p class="red--text">No treatment found! <v-btn x-small :href="'/clients/' + client.id + '/visits/' + visit.id + '/treatments/create'" @click.stop.prevent="goTo('/clients/' + client.id + '/visits/' + visit.id + '/treatments/create')">Add new</v-btn></p>
        </v-flex>
        <v-flex xs12 sm6 md4 v-for="treatment in treatments" :key="treatment.id" class="pa-1">
          <v-hover>
            <template v-slot:default="{ hover }">
              <v-card :href="'/clients/' + client.id + '/visits/' + visit.id + '/treatments/' + treatment.id" @click.stop.prevent="goTo('/clients/' + client.id + '/visits/' + visit.id + '/treatments/' + treatment.id)">
                <v-card-title>
                  <span class="text-muted">{{ treatment.name }}</span>{{ treatment.date }}
                </v-card-title>
                <v-card-text>
                  <prescription-view :client="client" :visit="visit" :treatment="treatment" :needed="false"></prescription-view>
                </v-card-text>
                <v-fade-transition>
                  <v-overlay
                    v-show="hover"
                    absolute
                    color="rgb(71 18 88 / 97%)"
                  >
                    <v-btn>See more info</v-btn>
                  </v-overlay>
                </v-fade-transition>
              </v-card>
            </template>
          </v-hover>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const PrescriptionView = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "treatments" */ '@/Components/Treatments/treatment')

  export default {
    name: 'Treatment',
    layout,
    props: [
      'treatments', 'client', 'visit'
    ],
    components: {
      PrescriptionView
    },
    metaInfo () {
      return {
        title: 'Prescriptions',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        overlay: false,
      }
    },
    methods: {
      somemethod () {},
    },
    computed: {},
    watch: {
      //
    }
  }
</script>
